export const POLICY_TOTAL_COST_QUERY_PREFIX = 'open-enrollment' as const
export const POLICY_TOTAL_COST_QUERY_KEYS = {
  all: [POLICY_TOTAL_COST_QUERY_PREFIX, 'oep-policy-total-cost'] as const,
  detail: (companyId: string) =>
    [
      POLICY_TOTAL_COST_QUERY_PREFIX,
      'oep-policy-total-cost',
      companyId,
    ] as const,
} as const
